import { SidebarMenuController } from './sidebar-menu.controller'

/* @ngInject */
function sidebarMenu ($state, $rootScope) {
  return {
    restrict: 'E',
    templateUrl: '/core/directives/sidebar-menu/sidebar-menu-directive.html?$$REVISION$$',
    controller: SidebarMenuController
  }
}

export { sidebarMenu }
